import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { FaTimes as RemoveIcon } from 'react-icons/fa';

import {
  BlackText,
  BoldText,
  ButtonText,
  RegularText,
  Text,
} from '../../components/common/Text';
import StyledTappable from '../../components/common/StyledTappable';
import { PrimaryButton } from '../../components/common/Buttons';
import LoadingComponent from '../../components/common/LoadingComponent';
import { FitcoinIcon } from '../../components/common/Fitcoin';
import { FlyInTransition } from '../../components/transitions/transitions';
import { getRewards, redeemProduct } from '../../services';
import RewardCard from '../../components/common/RewardCard';
import Modal from '../common/Modal';
import { setCurrentActiveTab, setFitcoinsBalance } from '../../actions';
import { logEvent } from '../../utils/logEvent';
import config from '../../config';

import errorModalBg from '../../images/common/error-modal-bg.svg';
import errorModalIcon from '../../images/common/error-modal.svg';

const OuterContainer = styled.div`
  padding: 0.875rem;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  background: #ffffff;
`;

const CategoryTitleText = styled(BoldText)`
  font-size: ${() => `${1.125 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  margin: 0.875rem;
`;

const EmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 2rem;
  flex: 1;
  flex-shrink: 0;
`;

const EmptyIcon = styled.img`
  padding-top: 8px;
  margin-bottom: 1.25rem;
`;

const EmptyText = styled(RegularText)`
  font-size: 1rem;
`;

const ModalContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: stretch;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.7);
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: white;
  padding: 0.75rem;
  border-radius: 0.625rem 0.625rem 0 0;
`;

const CloseContainer = styled(StyledTappable)`
  align-self: flex-end;
  padding: 0.5rem;
`;

const CloseIcon = styled(RemoveIcon)``;

const FitcoinText = styled(BlackText)`
  font-size: ${() => `${1.375 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  color: #d2a72b;
`;

const StyledButton = styled(PrimaryButton)`
  margin-top: 0.625rem;
`;

const ButtonTextContainer = styled.div`
  display: flex;
  align-items: center;
`;

const MyPurchaseContainer = styled.div`
  border-radius: 6px;
  border: 1px solid #8852cc;
  padding: 6px;
  font-size: 14px;
  color: #8852cc;
  font-weight: 600;
  cursor: pointer;
`;

const IframeContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const IframeOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: opacity 0.3s ease;
  opacity: ${(props) => (props.show ? 1 : 0)};
  pointer-events: ${(props) => (props.show ? 'auto' : 'none')};
`;

class RewardsTabContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rewards: [],
      loading: true,
      purchasing: false,
      showModal: false,
      modalVisible: false,
      selectedProduct: [],
      iframeLoaded: false,
    };
  }

  iframeRef = createRef();

  componentDidMount = () => {
    // GA Tracking
    window.gtag('event', 'screen_view', {
      screen_name: 'Rewards Products Tab',
    });
    logEvent('Redeem Tab');
    if (this.props.showHubbleRewards) {
      if (window.Hubble) {
        window.Hubble.setOptions({
          env: process.env.REACT_APP_BUILD_ENV,
          token: this.props.hubbleToken,
          clientId: config.hubbleClientId,
          clientSecret: config.hubbleClientSecret,
        });

        const hubbleUrl = window.Hubble.getUrl();

        this.iframeRef.current = hubbleUrl;
      } else {
        console.error('Hubble SDK not loaded yet.');
      }
      this.setState({ loading: false });
    } else {
      this.getRewards();
    }
  };

  confirmPurchase(ele) {
    this.setState({
      showModal: true,
      modalVisible: true,
      selectedProduct: ele,
    });
  }

  purchaseProduct = () => {
    this.setState({
      modalVisible: false,
      purchasing: true,
    });
    const { productId, type } = this.state.selectedProduct;
    const { authToken, history, phone, countryCode } = this.props;
    redeemProduct(productId, type, phone, countryCode, authToken)
      .then((res) => {
        const { couponCode } = res;
        history.push('/rewards/description', {
          product: {
            ...this.state.selectedProduct,
            redeemed: true,
            couponCode,
          },
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.setState({
          showModal: false,
          purchasing: false,
          selectedProduct: null,
        });
      });
  };

  getRewards() {
    const { authToken, dispatch } = this.props;
    getRewards(authToken)
      .then((res) => {
        const { store, walletBalance } = res;
        dispatch(setFitcoinsBalance(walletBalance));
        this.setState({
          rewards: store,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  }

  openReward(ele) {
    const { history } = this.props;
    history.push('/rewards/description', {
      product: ele,
    });
  }

  hideModal = () => {
    this.setState({ showModal: false });
  };

  closeModal = () => {
    this.setState({ modalVisible: false });
  };

  handleIframeLoad = () => {
    this.setState({ iframeLoaded: true });
  };

  render() {
    const {
      rewards,
      loading,
      purchasing,
      showModal,
      modalVisible,
      selectedProduct,
      iframeLoaded,
    } = this.state;

    const { showHubbleRewards } = this.props;
    this.props.dispatch(setCurrentActiveTab('rewards'));

    const renderReward = (ele, idx) => (
      <RewardCard
        key={idx}
        onTap={() => this.openReward(ele)}
        onPurchase={() => this.confirmPurchase(ele)}
        bgColor={ele.bgColor}
        logoUrl={ele.logoUrl}
        productName={ele.productName}
        offerLabel={ele.offerLabel}
        serviceImage={ele.serviceImage}
        cost={ele.cost}
        imageUrl={ele.imageLinks}
        layout={ele.layout}
      />
    );
    const renderRewardsCategory = (ele, idx) => {
      if (ele.products.length === 0) {
        return false;
      }
      return (
        <div key={idx}>
          <div className="flex flex-row justify-between items-center">
            <CategoryTitleText>{ele.label}</CategoryTitleText>
            {idx === 0 && (
              <div id={'extra-purchase-container'}>
                <MyPurchaseContainer
                  onClick={() => this.props.history.push('/rewards/history')}
                >
                  MY PURCHASES
                </MyPurchaseContainer>
              </div>
            )}
          </div>
          <div className="reward-cards-container">
            {ele.products.map(renderReward)}
          </div>
        </div>
      );
    };

    if (showHubbleRewards)
      return loading || !this.iframeRef.current ? (
        <LoadingComponent />
      ) : (
        <IframeContainer>
          <IframeOverlay show={!iframeLoaded}>
            <LoadingComponent />
          </IframeOverlay>
          <iframe
            src={this.iframeRef.current}
            title="Hubble Gift Cards"
            style={{ width: '100%', height: '100%', border: 'none' }}
            onLoad={this.handleIframeLoad}
          />
        </IframeContainer>
      );

    return (
      <OuterContainer>
        {loading ? (
          <LoadingComponent />
        ) : rewards.length === 0 ? (
          <>
            <EmptyContainer>
              <div
                style={{
                  backgroundImage: `url(${errorModalBg})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: '114px 114px',
                  backgroundPosition: 'center center',
                  textAlign: 'center',
                }}
              >
                <EmptyIcon src={errorModalIcon} />
              </div>
              <EmptyText>
                Oops! We could not find any rewards for you at the moment.
              </EmptyText>
            </EmptyContainer>
          </>
        ) : (
          rewards.map(renderRewardsCategory)
        )}
        {showModal && (
          <Modal>
            <ModalContainer>
              {purchasing ? (
                <LoadingComponent color="white" />
              ) : (
                <FlyInTransition
                  in={modalVisible}
                  mountOnEnter
                  unmountOnExit
                  onExited={this.hideModal}
                  appear
                >
                  <ModalBody>
                    <CloseContainer onTap={this.closeModal}>
                      <CloseIcon />
                    </CloseContainer>
                    <Text>{`You are about to unlock a ${selectedProduct.productName} coupon using`}</Text>
                    <ButtonTextContainer>
                      <FitcoinIcon />
                      <FitcoinText>{selectedProduct.cost}</FitcoinText>
                    </ButtonTextContainer>
                    <StyledButton onTap={this.purchaseProduct}>
                      <ButtonText>CONFIRM</ButtonText>
                    </StyledButton>
                  </ModalBody>
                </FlyInTransition>
              )}
            </ModalContainer>
          </Modal>
        )}
      </OuterContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  countryCode: state.user.countryCode,
  phone: state.user.userPhone,
  showHubbleRewards: state.app.config.showHubbleRewards,
  hubbleToken: state.app.config.hubbleToken,
});

export default connect(mapStateToProps)(RewardsTabContainer);
